import Component from './Component';
import Error from './Error';
import Gallery from './Gallery';
import { getApps } from '../utils/api';

/**
 * Homepage section listing the games hosted by the server, from server/apps.json.
 *
 * The manifest is the single source of truth, so a game appears here only once it is actually
 * deployed. Each game is a standalone build served from its own URL rather than a route in
 * this app, hence the full-page links. See docs/apps.md.
 */
class GameGallery extends Component {
  constructor(props) {
    super(props);
    this.state = { games: [], error: null };
  }

  async componentDidMount() {
    try {
      const { apps } = await getApps();
      this.setState({ games: this.toGalleryItems(apps) });
    } catch (err) {
      this.setState({ error: err.message });
    }
  }

  /** Reshape the manifest's games into the rows Gallery expects. */
  toGalleryItems = (apps) => (
    Object.values(apps)
      .filter(app => app.kind === 'game')
      .map(game => ({
        name: game.name,
        info: game.description,
        image: game.image,
        url: game.url,
      }))
  );

  render() {
    const { games, error } = this.state;

    // Nothing to announce on the homepage until there is something to show.
    if (!error && games.length === 0) return null;

    return (
      <>
        <div className="h1 m2 mrauto">Web Games</div>
        {error && <Error code="500" msg={error} />}
        {games.length > 0 && <Gallery className="games" apps={games} />}
      </>
    );
  }
}

export default GameGallery;
